import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

class TicketPrinter {
  constructor(config) {
    this.config = config || {
      nombreNegocio: 'Mi Tienda',
      direccion: '',
      telefono: '',
      rfc: '',
      logo: null
    };
  }

  // Generar PDF del ticket
  generatePDF(venta) {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [80, 297] // Ancho 80mm (ticket térmico estándar)
    });

    let yPos = 10;

    // Logo (si existe)
    if (this.config.logo) {
      try {
        doc.addImage(this.config.logo, 'PNG', 25, yPos, 30, 30);
        yPos += 35;
      } catch (e) {
        console.log('No se pudo cargar logo');
      }
    }

    // Nombre del negocio
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text(this.config.nombreNegocio, 40, yPos, { align: 'center' });
    yPos += 7;

    // Información del negocio
    doc.setFontSize(8);
    doc.setFont(undefined, 'normal');
    if (this.config.direccion) {
      doc.text(this.config.direccion, 40, yPos, { align: 'center' });
      yPos += 4;
    }
    if (this.config.telefono) {
      doc.text(`Tel: ${this.config.telefono}`, 40, yPos, { align: 'center' });
      yPos += 4;
    }
    if (this.config.rfc) {
      doc.text(`RFC: ${this.config.rfc}`, 40, yPos, { align: 'center' });
      yPos += 4;
    }

    // Línea separadora
    yPos += 2;
    doc.line(5, yPos, 75, yPos);
    yPos += 5;

    // Información de la venta
    doc.setFontSize(10);
    doc.setFont(undefined, 'bold');
    // Detectar si es venta mayorista
    const esMayorista = venta.tipo === 'mayorista' || venta.es_mayorista || venta.precio_mayoreo;
    const tituloTicket = esMayorista ? 'TICKET DE VENTA MAYORISTA' : 'TICKET DE VENTA';
    doc.text(tituloTicket, 40, yPos, { align: 'center' });
    yPos += 5;

    doc.setFontSize(8);
    doc.setFont(undefined, 'normal');
    doc.text(`Folio: ${venta.folio || venta.id}`, 5, yPos);
    yPos += 4;
    doc.text(`Fecha: ${new Date(venta.fecha_venta || new Date()).toLocaleString('es-MX')}`, 5, yPos);
    yPos += 4;
    if (venta.cliente_nombre) {
      doc.text(`Cliente: ${venta.cliente_nombre}`, 5, yPos);
      yPos += 4;
    }
    doc.text(`Atendió: ${venta.usuario_nombre || 'Sistema'}`, 5, yPos);
    yPos += 6;

    // Línea separadora
    doc.line(5, yPos, 75, yPos);
    yPos += 5;

    // Productos
    doc.setFont(undefined, 'bold');
    doc.text('Cant', 5, yPos);
    doc.text('Producto', 15, yPos);
    doc.text('P.Unit', 50, yPos);
    doc.text('Total', 65, yPos);
    yPos += 4;
    doc.line(5, yPos, 75, yPos);
    yPos += 4;

    doc.setFont(undefined, 'normal');
    venta.detalle.forEach(item => {
      // Cantidad
      doc.text(item.cantidad.toString(), 5, yPos);
      
      // Nombre del producto (cortado si es muy largo)
      const nombreCorto = item.producto_nombre.substring(0, 20);
      doc.text(nombreCorto, 15, yPos);
      
      // Precio unitario
      doc.text(`Q${parseFloat(item.precio_unitario).toFixed(2)}`, 50, yPos);
      
      // Subtotal
      const subtotal = item.cantidad * item.precio_unitario;
      doc.text(`Q${subtotal.toFixed(2)}`, 65, yPos);
      
      yPos += 4;

      // Si hay descuento
      if (item.descuento && item.descuento > 0) {
        doc.setFont(undefined, 'italic');
        doc.setFontSize(7);
        doc.text(`  - Desc: ${item.descuento}%`, 15, yPos);
        yPos += 3;
        doc.setFontSize(8);
        doc.setFont(undefined, 'normal');
      }
    });

    // Línea separadora
    yPos += 2;
    doc.line(5, yPos, 75, yPos);
    yPos += 5;

    // Totales
    doc.setFont(undefined, 'normal');
    doc.text('Subtotal:', 45, yPos);
    doc.text(`Q${parseFloat(venta.subtotal || 0).toFixed(2)}`, 65, yPos);
    yPos += 4;

    if (venta.descuento && venta.descuento > 0) {
      doc.text(`Descuento (${venta.descuento_porcentaje || 0}%)`, 45, yPos);
      doc.text(`-Q${parseFloat(venta.descuento).toFixed(2)}`, 65, yPos);
      yPos += 4;
    }

    if (venta.impuestos && venta.impuestos > 0) {
      doc.text('IVA:', 45, yPos);
      doc.text(`Q${parseFloat(venta.impuestos).toFixed(2)}`, 65, yPos);
      yPos += 4;
    }

    doc.setFont(undefined, 'bold');
    doc.setFontSize(10);
    doc.text('TOTAL:', 45, yPos);
    doc.text(`Q${parseFloat(venta.total).toFixed(2)}`, 65, yPos);
    yPos += 6;

    // Método de pago
    doc.setFont(undefined, 'normal');
    doc.setFontSize(8);
    doc.text(`Pago: ${venta.metodo_pago || 'Efectivo'}`, 5, yPos);
    yPos += 4;

    if (venta.pago_efectivo) {
      doc.text(`Efectivo: Q${parseFloat(venta.pago_efectivo).toFixed(2)}`, 5, yPos);
      yPos += 4;
      doc.text(`Cambio: Q${parseFloat(venta.cambio || 0).toFixed(2)}`, 5, yPos);
      yPos += 4;
    }

    // Línea separadora
    yPos += 2;
    doc.line(5, yPos, 75, yPos);
    yPos += 5;

    // Mensaje de agradecimiento
    doc.setFontSize(9);
    doc.setFont(undefined, 'bold');
    doc.text('¡GRACIAS POR SU COMPRA!', 40, yPos, { align: 'center' });
    yPos += 5;

    // Mensaje adicional
    doc.setFontSize(7);
    doc.setFont(undefined, 'italic');
    if (this.config.mensaje) {
      doc.text(this.config.mensaje, 40, yPos, { align: 'center' });
      yPos += 4;
    }

    // Código de barras (simulado con texto)
    if (venta.folio) {
      doc.setFontSize(6);
      doc.setFont('courier', 'normal');
      doc.text(venta.folio.toString(), 40, yPos, { align: 'center' });
    }

    return doc;
  }

  // Imprimir directamente
  print(venta) {
    const doc = this.generatePDF(venta);
    doc.autoPrint();
    window.open(doc.output('bloburl'), '_blank');
  }

  // Descargar PDF
  download(venta, filename) {
    const doc = this.generatePDF(venta);
    doc.save(filename || `ticket_${venta.folio || venta.id}.pdf`);
  }

  // Imprimir en impresora térmica (ESC/POS)
  printThermal(venta) {
    // Crear comando ESC/POS para impresora térmica
    let escpos = '';
    
    // Inicializar impresora
    escpos += '\x1B\x40'; // ESC @
    
    // Centrar texto
    escpos += '\x1B\x61\x01'; // ESC a 1
    
    // Texto grande
    escpos += '\x1B\x21\x30'; // ESC ! 48
    escpos += this.config.nombreNegocio + '\n';
    
    // Texto normal
    escpos += '\x1B\x21\x00'; // ESC ! 0
    if (this.config.direccion) escpos += this.config.direccion + '\n';
    if (this.config.telefono) escpos += 'Tel: ' + this.config.telefono + '\n';
    
    escpos += '================================\n';
    
    // Información de venta
    escpos += '\x1B\x61\x00'; // Alinear izquierda
    escpos += `Folio: ${venta.folio || venta.id}\n`;
    escpos += `Fecha: ${new Date().toLocaleString('es-MX')}\n`;
    if (venta.cliente_nombre) escpos += `Cliente: ${venta.cliente_nombre}\n`;
    escpos += '\n';
    
    // Productos
    escpos += 'Cant  Producto         P.Unit   Total\n';
    escpos += '================================\n';
    
    venta.detalle.forEach(item => {
      const cant = item.cantidad.toString().padEnd(6);
      const nombre = item.producto_nombre.substring(0, 15).padEnd(16);
      const precio = ('$' + item.precio_unitario.toFixed(2)).padStart(8);
      const total = ('$' + (item.cantidad * item.precio_unitario).toFixed(2)).padStart(7);
      escpos += `${cant}${nombre}${precio}${total}\n`;
    });
    
    escpos += '================================\n';
    
    // Totales
    escpos += `Subtotal:                $${venta.subtotal.toFixed(2)}\n`;
    if (venta.descuento > 0) {
      escpos += `Descuento:              -$${venta.descuento.toFixed(2)}\n`;
    }
    if (venta.impuestos > 0) {
      escpos += `IVA:                     $${venta.impuestos.toFixed(2)}\n`;
    }
    
    // Total en grande
    escpos += '\x1B\x21\x30'; // Texto grande
    escpos += '\x1B\x61\x01'; // Centrar
    escpos += `TOTAL: $${venta.total.toFixed(2)}\n`;
    
    escpos += '\x1B\x21\x00'; // Texto normal
    escpos += '================================\n';
    
    // Agradecimiento
    escpos += '\n';
    escpos += 'GRACIAS POR SU COMPRA\n';
    escpos += '\n\n\n';
    
    // Cortar papel
    escpos += '\x1D\x56\x00'; // GS V 0
    
    // Intentar imprimir
    this.sendToPrinter(escpos);
  }

  // Enviar a impresora térmica
  sendToPrinter(escposData) {
    // En navegador moderno, intentar usar Web Serial API
    if ('serial' in navigator) {
      this.printViaSerial(escposData);
    } else {
      // Fallback: mostrar diálogo de impresión del navegador
      console.log('Web Serial API no disponible');
      alert('Para imprimir en impresora térmica, usa el botón de PDF y luego imprime desde el visor de PDF');
    }
  }

  async printViaSerial(escposData) {
    try {
      const port = await navigator.serial.requestPort();
      await port.open({ baudRate: 9600 });
      
      const writer = port.writable.getWriter();
      const encoder = new TextEncoder();
      await writer.write(encoder.encode(escposData));
      writer.releaseLock();
      
      await port.close();
    } catch (error) {
      console.error('Error al imprimir:', error);
      alert('No se pudo conectar con la impresora térmica');
    }
  }
}

export default TicketPrinter;
